<template>
  <div v-if="getPermission.users.view">
    <user-form ref="CreateForm" mode="create"/>
    <user-form ref="UpdateForm" mode="update"/>
    <user-form ref="ResetForm" mode="reset"/>


    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-field>
              <label>Username</label>
              <md-input v-model="searchRequest.fromUsername" @keyup.enter="doSearch"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-field>
              <label>To</label>
              <md-input v-model="searchRequest.toUsername" @keyup.enter="doSearch"/>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <master-data-select
                label="Category"
                group="UserCategory"
                v-model="searchRequest.category"
            />

            <driver-group-select
                label="Driver Group"
                v-model="searchRequest.driverGroup">
            </driver-group-select>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100">
            <master-data-select
                label="Company"
                group="Company"
                v-model="searchRequest.companyId"
            />

            <md-checkbox v-model="showDisabled">
              <label>Show Disabled Users</label>
            </md-checkbox>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <calling-api :paths="['/api/w/users','/api/w/excel/generate']">
          <md-button v-if="getUsersToDisplay.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
          <md-button @click="doSearch" class="md-primary md-raised">Search</md-button>
          <md-button @click="clearSearch" class="md-raised">Clear</md-button>
        </calling-api>
      </md-card-actions>
    </md-card>


    <div v-if="getPermission.users.edit">
      <md-button @click="toggleCreate" class="md-fab-bottom-right md-fab md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>

    <pagination :items="getUsersToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w5" v-if="getPermission.users.edit"></th>
                    <th class="header-cell w10">
                      <sort :sort.sync="sort" field="username">
                        ID
                      </sort>
                    </th>
                    <th class="header-cell w3">MFA</th>
                    <th class="header-cell w5">MFA Type</th>
                    <th class="header-cell w5">Show TOTP</th>
                    <th class="header-cell w10">Name</th>
                    <th class="header-cell w5">Category</th>
                    <th class="header-cell w10">Company</th>
                    <th class="header-cell w5">Country</th>
                    <th class="header-cell w5">Mobile No</th>
                    <th class="header-cell w7">MFA Mobile No</th>
                    <th class="header-cell w10">Email</th>
                    <th class="header-cell w10">Sales office</th>
                    <th class="header-cell w10">Rec Window</th>
                    <th class="header-cell w5">Driver Group</th>
                    <th class="header-cell w5">Driver Region</th>
                    <th class="header-cell w5">Route Id</th>
                    <th class="header-cell w5">Route Desc</th>
                    <th class="header-cell w5">Dispatcher</th>
                    <th class="header-cell w5">End Outlet</th>
                    <th class="header-cell w5">Disabled</th>
                    <th class="header-cell w5">CCIC Group</th>
                    <th class="header-cell w5">CCIC Mail To</th>
                    <th class="header-cell w5">CCIC Mail CC</th>
                    <th class="header-cell w5">CCIC Team</th>
                    <th class="header-cell w5">CCIC Team Remark</th>
                    <th class="header-cell w5">CCIC Role</th>
                    <th class="header-cell w5">CCIC User Alias</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr v-for="item in pageItems" :key="item.username">
                    <td class="body-cell w5" v-if="getPermission.users.edit">
                      <md-button @click="toggleUpdate(item)" class="md-icon-button">
                        <md-icon>mode_edit</md-icon>
                      </md-button>
                      <md-button @click="toggleReset(item)" class="md-icon-button">
                        <md-icon>info_outline</md-icon>
                        <md-tooltip md-delay="300">Reset Password</md-tooltip>
                      </md-button>
                    </td>
                    <td class="body-cell w10">{{item.username}}</td>
                    <td class="body-cell w3">
                      <md-checkbox v-model="item.loginWithMFA" disabled></md-checkbox>
                    </td>
                    <td class="body-cell w5">{{ item.mfaMethod }}</td>
                    <td class="body-cell w5">
                      <md-checkbox v-model="item.firstTimeTOTP" disabled></md-checkbox>
                    </td>
                    <td class="body-cell w10">{{item.name}}</td>
                    <td class="body-cell w5">
                      <master-data-display group="UserCategory" :tag-id="item.category"/>
                    </td>
                    <td class="body-cell w10">{{item.companyName}}</td>
                    <td class="body-cell w5">{{item.country}}</td>
                    <td class="body-cell w5">{{item.mobileNo}}</td>
                    <td class="body-cell w7">{{item.mfaMobileNo}}</td>
                    <td class="body-cell w10">{{item.email}}</td>
                    <td class="body-cell w10">{{item.defaultSalesOffice}}</td>
                    <td class="body-cell w10">{{item.recWindow}}</td>
                    <td class="body-cell w5">{{item.driverGroup}}</td>
                    <td class="body-cell w5">{{item.driverRegion}}</td>
                    <td class="body-cell w5">{{item.routeId}}</td>
                    <td class="body-cell w5">{{item.routeDesc}}</td>
                    <td class="body-cell w5">{{item.dispatcher}}</td>
                    <td class="body-cell w5">{{item.endOutlet}}</td>
                    <td class="body-cell w5">
                      <md-checkbox disabled v-model="item.disabled"/>
                    </td>
                    <td class="body-cell w5">{{item.ccicSupplierGroup}}</td>
                    <td class="body-cell w5">
                      <div>
                        {{!!item.ccicEmailTo ? `${item.ccicEmailTo.split(';').length} email` : ''}}
                        <md-tooltip md-delay="300">{{item.ccicEmailTo}}</md-tooltip>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      <div>
                        {{!!item.ccicEmailCc ? `${item.ccicEmailCc.split(';').length} email` : ''}}
                        <md-tooltip md-delay="300">{{item.ccicEmailCc}}</md-tooltip>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      <div v-for="t in item.ccicTeams" :key="t.tagId">
                        <master-data-display group="CCIC_TEAM" :tag-id="t"/>
                      </div>
                    </td>
                    <td class="body-cell w5">
                      {{item.ccicTeamRemark}}
                    </td>
                    <td class="body-cell w5">
                      <master-data-display group="CCIC_ROLE" :tag-id="item.ccicRole"/>
                    </td>
                    <td class="body-cell w5">
                      {{item.ccicUserAlias}}
                    </td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w5">{{item.createdAt | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w5">{{item.updatedAt | time}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
</style>

<script>
  import { mapGetters } from 'vuex';
  import UserForm from '../components/UserForm.vue';
  import { sortList } from '../utils/sort';
  import toGenerateExcelRequest from '../utils/excel';
  import dateFormat from "../utils/dateFormat";

  const getInitSearchRequest = () => ({
    fromUsername: null,
    toUsername: null,
    category: null,
    companyId: null,
    driverGroup: null,
  });

  export default {
    data: () => ({
      searchRequest: getInitSearchRequest(),
      dialog: {
        isShowing: false,
      },
      showDisabled: false,
      sort: {
        field: `username`,
        ascending: true,
      },
    }),
    components: {
      UserForm,
    },
    computed: {
      ...mapGetters([
        'getUsers',
        'getMasterDataByGroup',
        'getMasterDataName',
        'getPermission',
      ]),
      getUsersToDisplay() {
        const fn = () => {
          if (this.showDisabled) {
            return this.getUsers;
          }
          return _(this.getUsers)
            .filter(it => !it.disabled);
        };
        return sortList(fn(), this.sort);
      },
    },
    mounted() {
      const cachedSearchRequest = this.$store.state.user.searchUserRequest;
      if (cachedSearchRequest) {
        this.searchRequest = cachedSearchRequest;
      }
    },
    methods: {
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left)
          });
      },
      toggleCreate() {
        this.$refs.CreateForm.openDialog();
      },
      toggleUpdate(user) {
        console.log(`toggleUpdate`, user);
        this.$refs.UpdateForm.openDialog(user);
      },
      toggleReset(user) {
        console.log(`toggleUpdate`, user);
        this.$refs.ResetForm.openDialog(user);
      },
      doSearch() {
        if (this.searchRequest.category === '') {
          this.searchRequest.category = null;
        }
        this.$store.dispatch('loadUsers', this.searchRequest);
      },
      clearSearch() {
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Users.xls',
          1,
        );

        request.rows = _(this.getUsersToDisplay)
          .map(item => [
            item.username,
            item.name,
            this.getMasterDataName('UserCategory', item.category),
            item.companyName,
            item.country,
            item.mobileNo,
            item.mfaMobileNo,
            item.email,
            item.defaultSalesOffice,
            item.driverGroup,
            item.driverRegion,
            item.routeId,
            item.routeDesc,
            item.dispatcher,
            item.endOutlet,
            item.disabled,
            item.ccicSupplierGroup,
            item.ccicEmailTo,
            item.ccicEmailCc,
            item.ccicTeams.join(','),
            item.ccicTeamRemark,
            item.ccicRole,
            item.ccicUserAlias,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
    },
  };

</script>
